import src from "IMAGE";
export default { src, width: 136, height: 102, blurWidth: 0, blurHeight: 0};
